import { Link } from "react-router-dom";
import { ArrowRight, AlertTriangle } from "lucide-react";

export default function CategoryCard({ category, index = 0 }) {
  return (
    <Link
      to={`/categories/${category.slug}`}
      className="cat-card group rounded-2xl block"
      data-testid={`category-card-${category.slug}`}
      style={{ animation: `fade-up 0.5s ease-out ${index * 60}ms both` }}
    >
      <div className="cat-bg-wrap">
        <div className="cat-bg" style={{ backgroundImage: `url(${category.image_url})` }} />
        {category.disclaimer_type === "danger" && (
          <span className="absolute top-3 left-3 inline-flex items-center gap-1 text-[10px] uppercase tracking-widest text-white font-medium bg-danger/90 px-2 py-1 rounded-full">
            <AlertTriangle className="w-3 h-3" /> Médical
          </span>
        )}
        {category.disclaimer_type === "warning" && (
          <span className="absolute top-3 left-3 inline-flex items-center gap-1 text-[10px] uppercase tracking-widest text-white font-medium bg-warning/90 px-2 py-1 rounded-full">
            <AlertTriangle className="w-3 h-3" /> Théorique
          </span>
        )}
      </div>

      <div className="p-5">
        <div className="font-mono text-[10px] tracking-widest uppercase text-gold-600 mb-1">
          Catégorie · {String(index + 1).padStart(2, "0")}
        </div>
        <h3 className="font-display text-xl font-semibold text-ink-900 leading-tight">{category.name}</h3>
        <div className="flex items-center justify-between mt-3">
          <span className="text-xs text-ink-500">{category.certifications_count} certifications</span>
          <span className="inline-flex items-center gap-1 text-gold-600 text-sm font-medium group-hover:gap-2 transition-all">
            Découvrir <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </div>
    </Link>
  );
}
